// SwatchKingKiwi v1.0
document.addEventListener('DOMContentLoaded', function() {
    // If this comes in console, remove Kiwi from product block, and the snippet instead
    if (typeof loadKiwiSizingChart !== "function") {
     console.warn("loadKiwiSizingChart() function is not globally accessible. Please add Kiwi snippet in the theme /snippets.");
     return;
   }
 
   function injectKiwiChart() {
     let pollInterval;
     
     function injectChart(legendElement, fetchKiwiChart) {
       if (legendElement && fetchKiwiChart && !legendElement.contains(fetchKiwiChart)) {
         legendElement.appendChild(fetchKiwiChart);
         fetchKiwiChart.style.marginLeft = '15px';
         fetchKiwiChart.style.display = 'inline';
         clearInterval(pollInterval); 
       }
     }
 
     pollInterval = setInterval(function() {
       //target Swatch King main container
       let productBlocks = document.querySelector("variant-swatch-king");
       //define Kiwi container and target section
       if (productBlocks) {
         const fetchKiwiChart = document.querySelector('.ks-chart-modal-link.sizing-chart-modal-link.with-icon');
         const legendElement = document.querySelector('label.swatch-label.swatch-label-button');
         //append + CSS 
         injectChart(legendElement, fetchKiwiChart);
         fetchKiwiChart.style.marginLeft = '15px';
         fetchKiwiChart.style.display = 'inline';
         
       } else {
         // add something for fallback if there are products without Variant Swatch King. Otherwise leave blank.
       }
     }, 100);
   }
 
   injectKiwiChart();
   
 });
 